import { render, staticRenderFns } from "./expander.vue?vue&type=template&id=887c6e28"
import script from "./expander.vue?vue&type=script&lang=js"
export * from "./expander.vue?vue&type=script&lang=js"
import style0 from "./expander.vue?vue&type=style&index=0&id=887c6e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports